export default __webpack_public_path__ + "static/media/iDocFont-20.d6450425.woff";